import React from 'react';
import { cn } from '@/lib/utils';

interface CategoryTab {
  id: string;
  label: string;
}

interface CategoryTabsProps {
  categories: CategoryTab[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
  className?: string;
}

/**
 * CategoryTabs - Horizontal category tabs matching design system
 * Active: text-[#F9FAFB] border-b-2 border-[#1D4ED8]
 * Inactive: text-[#9CA3AF] hover:text-[#E5E7EB]
 * Uses font-mono text-xs
 */
export const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
  className,
}) => {
  return (
    <div className={cn('flex flex-wrap gap-2 border-b border-nb-border-subtle pb-4', className)}>
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onCategoryChange(cat.id)}
          className={cn(
            'px-3 py-1.5 text-xs transition-colors',
            activeCategory === cat.id
              ? 'text-nb-text-primary border-b-2 border-nb-accent'
              : 'text-nb-text-muted hover:text-nb-text-secondary'
          )}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
};






